import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WhyWorkWithOpal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="49915" id="why-bvp-group" className="dark bg-background text-foreground py-[200px] relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-12 gap-y-12 md:gap-x-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="md:col-span-5 flex flex-col justify-start">
            <span className="font-serif text-[8rem] md:text-[12rem] lg:text-[16rem] leading-[0.8] font-thin opacity-20 text-primary select-none tracking-tighter">
              01
            </span>
          </div>

          {}
          <div className="md:col-start-6 md:col-span-7 flex flex-col gap-10 pt-4 md:pt-12">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-semibold tracking-wide text-foreground">
              London Masterpiece
            </h2>
            
            <div className="space-y-8">
              <p className="font-sans text-lg md:text-xl font-light leading-relaxed text-muted-foreground/90">
                BVP Group transforms London residences into architectural masterpieces. Our focus on Victorian and Edwardian renovations ensures your period home retains its timeless heritage while embracing modern luxury and light-filled open-plan living.
              </p>
              
              <p className="font-sans text-lg md:text-xl font-light leading-relaxed text-muted-foreground/90">
                From high-end kitchen extensions to seamless bi-fold door installations, our craftsmanship is defined by precision and elegance. We specialise in creating bespoke spaces that enhance your lifestyle and significantly increase your property value.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 pt-8 border-t border-primary/20">
                <div className="space-y-2">
                  <h3 className="font-serif text-2xl text-primary font-medium">London Specialist</h3>
                  <p className="text-sm text-muted-foreground font-light leading-relaxed">
                    Deep expertise in navigating the unique structural challenges and planning requirements of London's historic period properties.
                  </p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-serif text-2xl text-primary font-medium">Premium Craftsmanship</h3>
                  <p className="text-sm text-muted-foreground font-light leading-relaxed">
                    Utilizing the finest materials and project management techniques to deliver a stress-free renovation with an impeccable finish.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}